<script>
import {useI18n} from "vue-i18n";
import Icon from "./Icon.vue";
import {useUserStore} from "../../stores/user";

export default {
  components: {Icon},
  setup() {
    const userStore = useUserStore();

    // I18n
    const {t} = useI18n();
    return {
      t,
      userStore,
    };
  }
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <div class="text-xl font-bold mb-4">
      {{ t('generic_errors.unauthorized') }}
    </div>
    <div
      v-if="userStore.user"
      class="cursor-pointer px-4 py-2 my-5 mb-2 flex flex-row"
      @click="userStore.signOut"
    >
      <span class="mr-10">{{ t("admin.controls.logout") }}</span>
      <icon icon="logout" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
